<section class="briefing-section-card" aria-labelledby="voucher-codes-title">
<div>
  <div class="flex flex-wrap items-start justify-between gap-3">
    <div class="min-w-0">
      <h3 id="voucher-codes-title" class="m-0 text-base font-semibold text-gray-900 dark:text-zinc-100">
        @if (isUnique()) { Voucher codes } @else { Voucher }
      </h3>
      @if (method(); as m) {
      <p class="m-0 mt-0.5 text-sm text-gray-500 dark:text-zinc-400">
        {{ m.name }}
        @if (isShopify()) { · each creator's single-use code is created in Shopify when they complete the brief }
        @else if (isUnique()) { · each creator gets their own single-use code when they complete the brief }
      </p>
      }
    </div>
    @if (isUnique() && !isShopify()) {
    <button type="button" class="btn-shout btn-shout-sm btn-shout-plus-gradient" [attr.aria-expanded]="adding()"
      aria-controls="voucher-codes-add" (click)="toggleAdding()">
      {{ adding() ? 'Cancel' : 'Add codes' }}
    </button>
    }
  </div>

  @if (loading()) {
  <p class="m-0 mt-4 text-sm text-gray-500 dark:text-zinc-400">Loading voucher…</p>
  } @else if (loadError()) {
  <p class="m-0 mt-4 text-sm text-rose-600 dark:text-rose-400" role="alert">We couldn't load this voucher. Refresh the page to try again.</p>
  } @else if (!isUnique()) {
  <!-- One shared code for everyone -->
  <div class="mt-4 flex flex-wrap items-center gap-3 rounded-xl bg-gray-50 px-4 py-3 dark:bg-white/5">
    <span class="text-sm text-gray-500 dark:text-zinc-400">Coupon code (same for every creator)</span>
    <span class="font-mono text-sm font-semibold text-gray-900 dark:text-zinc-100">{{ method()?.code || '—' }}</span>
  </div>
  } @else {
  <!-- Counts -->
  @if (summary(); as s) {
  @if (isShopify()) {
  <dl class="m-0 mt-4 grid grid-cols-1 gap-3 sm:max-w-xs">
    <div class="rounded-xl bg-emerald-50 px-4 py-3 dark:bg-emerald-500/10">
      <dt class="text-xs text-emerald-800 dark:text-emerald-300">Codes created in Shopify</dt>
      <dd class="m-0 mt-0.5 text-lg font-semibold text-emerald-900 dark:text-emerald-200">{{ s.assigned }}</dd>
    </div>
  </dl>
  } @else {
  <dl class="m-0 mt-4 grid grid-cols-3 gap-3">
    <div class="rounded-xl bg-gray-50 px-4 py-3 dark:bg-white/5">
      <dt class="text-xs text-gray-500 dark:text-zinc-400">Total</dt>
      <dd class="m-0 mt-0.5 text-lg font-semibold text-gray-900 dark:text-zinc-100">{{ s.total }}</dd>
    </div>
    <div class="rounded-xl bg-gray-50 px-4 py-3 dark:bg-white/5">
      <dt class="text-xs text-gray-500 dark:text-zinc-400">Given out</dt>
      <dd class="m-0 mt-0.5 text-lg font-semibold text-gray-900 dark:text-zinc-100">{{ s.assigned }}</dd>
    </div>
    <div class="rounded-xl px-4 py-3" [class]="s.remaining <= 5 ? 'bg-amber-50 dark:bg-amber-500/10' : 'bg-emerald-50 dark:bg-emerald-500/10'">
      <dt class="text-xs" [class]="s.remaining <= 5 ? 'text-amber-800 dark:text-amber-300' : 'text-emerald-800 dark:text-emerald-300'">Left</dt>
      <dd class="m-0 mt-0.5 text-lg font-semibold" [class]="s.remaining <= 5 ? 'text-amber-900 dark:text-amber-200' : 'text-emerald-900 dark:text-emerald-200'">{{ s.remaining }}</dd>
    </div>
  </dl>
  }
  }
  @if (stockWarning(); as warning) {
  <p class="m-0 mt-3 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:bg-amber-500/10 dark:text-amber-200" role="status">{{ warning }}</p>
  }

  <!-- Add codes -->
  @if (adding()) {
  <div id="voucher-codes-add" class="mt-4 rounded-xl border border-gray-200 p-4 dark:border-white/10">
    <label for="voucher-codes-add-input" class="text-sm font-medium text-gray-900 dark:text-zinc-100">New codes</label>
    <p id="voucher-codes-add-hint" class="m-0 mt-0.5 text-sm text-gray-500 dark:text-zinc-400">
      Paste single-use codes from your store, one per line, or upload a CSV. Codes already in your list are skipped.
    </p>
    <textarea id="voucher-codes-add-input" rows="5" spellcheck="false" aria-describedby="voucher-codes-add-hint"
      class="mt-2 w-full rounded-lg border border-gray-200 bg-white px-3 py-2 font-mono text-sm text-gray-900 focus:border-zinc-400 focus:outline-none focus:ring-2 focus:ring-zinc-300 dark:border-white/10 dark:bg-white/5 dark:text-zinc-100"
      placeholder="JADE-15OFF&#10;SAM-15OFF" [value]="addText()" (input)="onAddInput($event)"></textarea>
    <div class="mt-3 flex flex-wrap items-center justify-between gap-3">
      <label class="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:border-gray-300 focus-within:ring-2 focus-within:ring-zinc-400 dark:border-white/10 dark:bg-white/5 dark:text-zinc-200">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" x2="12" y1="3" y2="15" />
        </svg>
        Upload CSV
        <input type="file" accept=".csv,.txt,text/csv,text/plain" class="sr-only" (change)="onAddFile($event)">
      </label>
      <button type="button" class="btn-shout btn-shout-sm btn-shout-plus-gradient" [disabled]="!pendingCodes().length || saving()"
        (click)="saveCodes()">
        @if (saving()) { Adding… } @else if (pendingCodes().length) { Add {{ pendingCodes().length }} {{ pendingCodes().length === 1 ? 'code' : 'codes' }} } @else { Add codes }
      </button>
    </div>
  </div>
  }

  @if (message(); as m) {
  <p class="m-0 mt-3 text-sm" [class]="m.kind === 'error' ? 'text-rose-600 dark:text-rose-400' : 'text-emerald-700 dark:text-emerald-300'"
    [attr.role]="m.kind === 'error' ? 'alert' : 'status'">{{ m.text }}</p>
  }

  <!-- Codes table -->
  <div class="mt-5">
    <label for="voucher-codes-search" class="sr-only">Search codes</label>
    <input id="voucher-codes-search" type="search" placeholder="Search codes"
      class="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:border-zinc-400 focus:outline-none focus:ring-2 focus:ring-zinc-300 sm:max-w-xs dark:border-white/10 dark:bg-white/5 dark:text-zinc-100"
      [value]="search()" (input)="onSearchInput($event)">

    @if (!rows().length && !loadingRows()) {
    <p class="m-0 mt-4 rounded-xl bg-gray-50 px-4 py-6 text-center text-sm text-gray-500 dark:bg-white/5 dark:text-zinc-400">
      @if (search()) { No codes match "{{ search() }}". } @else if (isShopify()) { No codes yet. Each one appears here when its creator completes the brief. } @else { No codes yet. Add some so creators get one when they complete. }
    </p>
    } @else {
    <ul class="m-0 mt-3 list-none divide-y divide-gray-100 rounded-xl border border-gray-200 p-0 dark:divide-white/10 dark:border-white/10">
      @for (row of rows(); track row.id) {
      <li class="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3">
        <span class="min-w-[9rem] font-mono text-sm font-semibold text-gray-900 dark:text-zinc-100">{{ row.code }}</span>

        @if (row.status === 'assigned') {
        <span class="order-last flex min-w-0 basis-full items-center gap-2 sm:order-none sm:basis-0 sm:flex-1">
          <span class="relative flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-100 text-[10px] font-semibold text-gray-600 dark:bg-white/5 dark:text-zinc-300" aria-hidden="true">
            {{ creatorInitials(row) }}
            @if (row.creator?.photoURL) {
            <img [src]="imageService.getImageSource(row.creator!.photoURL, 'gallery')" alt="" class="absolute inset-0 size-full object-cover" loading="lazy" onerror="this.remove()">
            }
          </span>
          <span class="truncate text-sm text-gray-700 dark:text-zinc-300">Given to <span class="font-medium text-gray-900 dark:text-zinc-100">{{ creatorName(row) }}</span></span>
        </span>
        <span class="ml-auto text-xs text-gray-500 sm:ml-0 dark:text-zinc-400">{{ row.assigned_at | date: 'd MMM yyyy' }}</span>
        } @else {
        <span class="flex-1">
          <span class="rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300">Available</span>
        </span>
        <button type="button"
          class="cursor-pointer rounded-md px-2 py-1 text-sm font-medium text-gray-500 hover:bg-rose-50 hover:text-rose-600 disabled:cursor-not-allowed disabled:opacity-50 dark:text-zinc-400 dark:hover:bg-rose-500/10"
          [attr.aria-label]="'Remove ' + row.code" [disabled]="removingId() === row.id" (click)="removeCode(row)">
          {{ removingId() === row.id ? 'Removing…' : 'Remove' }}
        </button>
        }
      </li>
      }
    </ul>
    <div class="mt-3 flex items-center justify-between gap-3 text-sm text-gray-500 dark:text-zinc-400">
      <span>Showing {{ rows().length }} of {{ total() }}</span>
      @if (hasMore()) {
      <button type="button" class="cursor-pointer font-medium text-gray-700 underline underline-offset-2 hover:text-gray-900 disabled:opacity-50 dark:text-zinc-200"
        [disabled]="loadingRows()" (click)="loadRows(false)">
        {{ loadingRows() ? 'Loading…' : 'Show more' }}
      </button>
      }
    </div>
    }
  </div>

  <!-- Sales from these codes -->
  <div class="mt-6 border-t border-gray-100 pt-5 dark:border-white/10" aria-labelledby="voucher-sales-title">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div class="min-w-0">
        <h4 id="voucher-sales-title" class="m-0 text-sm font-semibold text-gray-900 dark:text-zinc-100">Sales by creator</h4>
        <p id="voucher-sales-hint" class="m-0 mt-0.5 max-w-xl text-sm text-gray-500 dark:text-zinc-400">
          Upload your store's order export (Shopify, WooCommerce or any CSV with order number, discount code and total). We match each order to the creator whose code was used.
        </p>
      </div>
      <label class="inline-flex shrink-0 cursor-pointer items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 hover:border-gray-300 focus-within:ring-2 focus-within:ring-zinc-400 dark:border-white/10 dark:bg-white/5 dark:text-zinc-200"
        [class.opacity-60]="importing()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" class="size-4" aria-hidden="true">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" x2="12" y1="3" y2="15" />
        </svg>
        @if (importing()) { Importing… } @else { Import orders }
        <input type="file" accept=".csv,text/csv" class="sr-only" aria-describedby="voucher-sales-hint"
          [disabled]="importing()" (change)="onImportOrders($event)">
      </label>
    </div>

    @if (salesMessage(); as m) {
    <p class="m-0 mt-3 text-sm" [class]="m.kind === 'error' ? 'text-rose-600 dark:text-rose-400' : 'text-emerald-700 dark:text-emerald-300'"
      [attr.role]="m.kind === 'error' ? 'alert' : 'status'">{{ m.text }}</p>
    }

    @if (sales(); as s) {
    @if (s.orders) {
    <dl class="m-0 mt-4 grid grid-cols-2 gap-3 sm:max-w-sm">
      <div class="rounded-xl bg-gray-50 px-4 py-3 dark:bg-white/5">
        <dt class="text-xs text-gray-500 dark:text-zinc-400">Orders</dt>
        <dd class="m-0 mt-0.5 text-lg font-semibold text-gray-900 dark:text-zinc-100">{{ s.orders }}</dd>
      </div>
      <div class="rounded-xl bg-emerald-50 px-4 py-3 dark:bg-emerald-500/10">
        <dt class="text-xs text-emerald-800 dark:text-emerald-300">Revenue</dt>
        <dd class="m-0 mt-0.5 text-lg font-semibold text-emerald-900 dark:text-emerald-200">{{ formatMoney(s.revenue) }}</dd>
      </div>
    </dl>
    <ul class="m-0 mt-3 list-none divide-y divide-gray-100 rounded-xl border border-gray-200 p-0 dark:divide-white/10 dark:border-white/10"
      aria-label="Sales by creator">
      @for (row of s.creators; track row.creator.id) {
      <li class="flex flex-wrap items-center gap-x-4 gap-y-1 px-4 py-3">
        <span class="flex min-w-0 flex-1 items-center gap-2">
          <span class="relative flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gray-100 text-[10px] font-semibold text-gray-600 dark:bg-white/5 dark:text-zinc-300" aria-hidden="true">
            {{ salesCreatorInitials(row) }}
            @if (row.creator.photoURL) {
            <img [src]="imageService.getImageSource(row.creator.photoURL, 'gallery')" alt="" class="absolute inset-0 size-full object-cover" loading="lazy" onerror="this.remove()">
            }
          </span>
          <span class="truncate text-sm font-medium text-gray-900 dark:text-zinc-100">{{ salesCreatorName(row) }}</span>
          @if (row.code) {
          <span class="font-mono text-xs text-gray-500 dark:text-zinc-400">{{ row.code }}</span>
          }
        </span>
        <span class="text-sm text-gray-500 dark:text-zinc-400">{{ row.orders }} {{ row.orders === 1 ? 'order' : 'orders' }}</span>
        <span class="min-w-[5rem] text-right text-sm font-semibold text-gray-900 dark:text-zinc-100">{{ formatMoney(row.revenue) }}</span>
      </li>
      }
    </ul>
    } @else {
    <p class="m-0 mt-4 rounded-xl bg-gray-50 px-4 py-6 text-center text-sm text-gray-500 dark:bg-white/5 dark:text-zinc-400">
      No sales yet. Import an order export to see what each creator's code has sold.
    </p>
    }
    }
  </div>
  }
</div>
</section>
